import axios from 'axios';
import { authHeader } from './auth-header';

export const announcementService = {
    getAll,
    getActive,
    getArchive,
    getActiveCount,
    getForCamera,
    getCameraOptions,
    create,
    update,
    destroy
};

function getAll({
    pageSize,
    page,
    search,
    orderBy,
    sortColumn,
    category
}) {
    return axios.get('/announcement', {
        params: {
            pageSize,
            page,
            search,
            orderBy,
            sortColumn,
            category
        },
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}

function getActive({
    pageSize,
    page,
    search,
    orderBy,
    sortColumn,
    category
}) {
    return axios.get('/announcement/active', {
        params: {
            pageSize,
            page,
            search,
            orderBy,
            sortColumn,
            category
        },
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}

function getArchive({
    pageSize,
    page,
    search,
    orderBy,
    sortColumn,
    category
}) {
    return axios.get('/announcement/archive', {
        params: {
            pageSize,
            page,
            search,
            orderBy,
            sortColumn,
            category
        },
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}

function getActiveCount() {
    return axios.get('/announcement/active-count', {
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}

// cameraId is the external camera identifier carried on traffic_record.camera_id
function getForCamera(cameraId) {
    return axios.get(`/announcement/camera/${cameraId}`, {
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}

function getCameraOptions() {
    return axios.get('/announcement/camera-options', {
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}

function create(data) {
    return axios.post('/announcement', data, {
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}

function update(data) {
    return axios.put(`/announcement/${data.id}`, data, {
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}

function destroy(id) {
    return axios.delete(`/announcement/${id}`, {
        headers: authHeader()
    })
    .then(({ data }) => {
        return data;
    })
}